module.exports = __webpack_public_path__ + "static/media/stefaanVanDenBogaert.e9df52ae.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/authorSpotlight/stefaanVanDenBogaert.jpg
// module id = 1696
// module chunks = 1